// extracted by mini-css-extract-plugin
export var column = "_tn-0";
export var divider = "_tn-2";
export var timePicker = "_tn-1";